import React from 'react'

import {
  PRIVACY_POLICY_LINK,
  TERMS_CONDITIONS_LINK,
} from '../../config'
import { useAppCopy } from '../../hooks'

interface FooterProps {
  minimal?: boolean;
}

function Footer({ minimal = false }: FooterProps) {
  const appCopy = useAppCopy()
  const year = new Date().getFullYear()

  if (minimal) {
    return <footer className="py-4" />;
  }

  return (
    <footer className="flex flex-col gap-4 justify-center w-full text-center px-6 text-sm">
      <ul className="flex gap-4 justify-center w-full text-center [&_li:not(:first-child)]:border-l [&_li:not(:first-child)]:border-neutral-200 [&_li:not(:first-child)]:border-solid [&_li:not(:first-child)]:pl-4">
        <li>
          <a href={TERMS_CONDITIONS_LINK} target="_blank" rel="noopener noreferrer">{appCopy("termsOfUse")}</a>
        </li>
        <li>
          <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">{appCopy("privacyPolicy")}</a>
        </li>
      </ul>
      <p>&#169; {`${year} Prosci Inc. ${appCopy("allRightsReserved")}`}</p>
    </footer>
  );
}


export default Footer
